import { exMutation, veloeGraphQlApi } from '../api/graphql/graphQLAPI';

import dadosPessoaisFCG from '../mutations/dadosPessoais';

export const ASYNC_SALVAR_DADOS_USUARIO = 'ASYNC_SALVAR_DADOS_USUARIO';
export const ASYNC_SALVAR_LISTA_PRODUTOS = 'ASYNC_SALVAR_LISTA_PRODUTOS';
export const ASYNC_SALVAR_VALOR_RECARGA = 'ASYNC_SALVAR_VALOR_RECARGA';
export const ASYNC_SALVAR_TIPO_VEICULO = 'ASYNC_SALVAR_TIPO_VEICULO';
export const ASYNC_SALVAR_CODIGO_PROMOCIONAL =
  'ASYNC_SALVAR_CODIGO_PROMOCIONAL';
export const ASYNC_SALVAR_DESCONTO = 'ASYNC_SALVAR_DESCONTO';
export const ASYNC_ONDE_USAR = 'ASYNC_ONDE_USAR';
export const ASYNC_RECEBER_ADESIVO = 'ASYNC_RECEBER_ADESIVO';
export const ASYNC_ONDE_RECEBER = 'ASYNC_ONDE_RECEBER';
export const ASYNC_TIPO_PAGAMENTO = 'ASYNC_TIPO_PAGAMENTO';
export const ASYNC_TOTAL_PRODUTOS = 'ASYNC_TOTAL_PRODUTOS';

/**
 * Salva as informações assíncronas de pagamento
 * */
export const tipoPagamentoAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_TIPO_PAGAMENTO, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva as informações assíncronas de produto
 * */
export const totalProdutosAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_TOTAL_PRODUTOS, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva os locais de uso assíncronos
 * */
export const ondeUsarAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_ONDE_USAR, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva o desconto assíncrono
 * */
export const salvarDescontoAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_SALVAR_DESCONTO, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva se o usuario quer ou nao receber adesivo em casa  (assíncrona)
 * */
export const receberAdesivoAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_RECEBER_ADESIVO, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva o endereço do usuário assíncrono
 * */
export const ondeReceberAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_ONDE_RECEBER, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva os dados do Veículo assíncronos
 * */
export const salvarTipoVeiculoAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_SALVAR_TIPO_VEICULO, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva os dados do cupom promocional
 * */
export const salvarCupomPromocionalAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_SALVAR_TIPO_VEICULO, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva os produtos selecionados assíncronos
 * */
export const salvarListaProdutosAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_SALVAR_LISTA_PRODUTOS, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva o valor de recarga assíncrono
 * */
export const salvaValorRecargaAsync = (variables) => async (dispatch) => {
  try {
    const query = exMutation;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_SALVAR_VALOR_RECARGA, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};

/**
 * Salva os dados assíncronos do Usuário pela API
 * */
export const salvarDadosUsuarioAsync = (variables) => async (dispatch) => {
  try {
    const query = dadosPessoaisFCG;
    const media = await veloeGraphQlApi(query, variables);
    dispatch({ type: ASYNC_SALVAR_DADOS_USUARIO, media });
    return media;
  } catch (e) {
    // capture os erros aqui
  }
};
